import { ApiResponse, getRequest } from "@/data/apiClient";

export interface Connection {
  userId: number;
  userName: string;
  lastActiveTs: string;
  clientAddress: string;
  apps: string[];
}

export const getConnections = async (): Promise<ApiResponse<Connection[]>> =>
  getRequest("connections/list", {});
